import './SurpriseMeForm.css';
import React, { useEffect, useRef, useState } from 'react';
import { canUseDOM, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { ReactComponent as IconClose } from '../../resources/icons/close.svg';
import { ReactComponent as IconMailBox } from '../../resources/icons/mailBox.svg';
import { get } from '../../utils/getPropertyByPath';
import { isNil, isNotNil } from '../../utils/IsNil';
import { useLocation } from 'react-router-dom';
import { convertToAnalyticObject } from '../../utils/analytics';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { splitter } from '../Listing';
import { qsToObject } from '../../utils/querystring';
import { checkJssError } from '../../utils/checkJssError';
const SurpriseMeFormComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [isVdsite, setIsVdsite] = useState(true);
  const [openForm, setOpenForm] = useState(false);
  const [emailInputValue, setEmailInputValue] = useState("");
  const [checkboxValue, setCheckboxValue] = useState(false);
  const [emailSentSuccessful, setEmailSentSuccessful] = useState(false);
  const timerOpenFormId = useRef(null);
  const location = useLocation();
  const language = get(sitecoreContext, 'language') || 'en';
  const title = get(fields, "data.listingConfiguration.title.jss.value");
  const subtitle = get(fields, "data.listingConfiguration.subtitle.jss.value");
  const subscriptionText = get(fields, "data.listingConfiguration.subscriptionText.jss.value");
  const policyText = get(fields, "data.listingConfiguration.policyText.jss.value");
  const buttonText = get(fields, "data.listingConfiguration.buttonText.jss.value");
  const successMessageTitle = get(fields, "data.listingConfiguration.successMessageTitle.jss.value");
  const successMessageText = get(fields, "data.listingConfiguration.successMessageText.jss.value");
  const aPIUrl = get(fields, "data.apiConfigurations.aPIUrl.value");
  useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
    timerOpenFormId.current = setTimeout(() => {
      setOpenForm(true);
      analyticsPopupLoadedHandler();
    }, 5000);
  }, []);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.apiConfigurations) || isNil(fields.data.listingConfiguration) || isNil(fields.data.listingConfiguration.travelerTypes) || isNil(fields.data.listingConfiguration.activityInterests) || isNil(fields.data.listingConfiguration.tripTypes) || !fields.data.listingConfiguration.travelerTypes.targetItem || !fields.data.listingConfiguration.activityInterests.targetItem || !fields.data.listingConfiguration.tripTypes.targetItem) {
    console.info('SurpriseMeForm component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [SurpriseMeForm component is empty: please provide data source]");
    }
    return null;
  }
  const travelerTypes = get(fields, "data.listingConfiguration.travelerTypes.targetItem");
  const activityInterests = get(fields, "data.listingConfiguration.activityInterests.targetItem");
  const tripTypes = get(fields, "data.listingConfiguration.tripTypes.targetItem");
  const filtersTravelerTypes = travelerTypes.tagsToDisplay.values.map(_ref2 => {
    let {
      title
    } = _ref2;
    return title.value;
  });
  const filtersActivityInterests = activityInterests.tagsToDisplay.values.map(_ref3 => {
    let {
      title
    } = _ref3;
    return title.value;
  });
  const filtersTripTypes = tripTypes.tagsToDisplay.values.map(_ref4 => {
    let {
      title
    } = _ref4;
    return title.value;
  });
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const getFilterTypes = () => {
    const types = [travelerTypes, activityInterests, tripTypes];
    const set = new Set();
    types.forEach(type => set.add(type.fieldNameItem.item.fieldName.value));
    return Array.from(set);
  };
  const createQueryParams = () => {
    const queryParams = canUseDOM ? qsToObject(location.search) : {};
    if (Object.keys(queryParams).length !== 0) {
      for (let key in queryParams) {
        const newKeys = key.split('+').join(' ');
        queryParams[newKeys] = queryParams[key].split(splitter).join(', ');
        queryParams[newKeys] = replaceUrlPluses(queryParams[newKeys]) || queryParams[newKeys];
        if (key !== newKeys) {
          delete queryParams[key];
        }
      }
    }
    return queryParams;
  };
  const getFormDataFromQueryString = () => {
    const queryParams = createQueryParams();
    const travellerTypeArray = [];
    const leasureInterestArray = [];
    const packageTypeArray = [];
    const filterTypes = getFilterTypes();
    for (const [key, value] of Object.entries(queryParams)) {
      if (filterTypes.includes(key)) {
        value.split(", ").forEach(el => {
          const trimEl = el.trim();
          if (filtersTravelerTypes.includes(trimEl)) {
            travellerTypeArray.push(trimEl);
          }
          if (filtersActivityInterests.includes(trimEl)) {
            leasureInterestArray.push(trimEl);
          }
          if (filtersTripTypes.includes(trimEl)) {
            packageTypeArray.push(trimEl);
          }
        });
      }
    }
    return {
      travellerTypeArray,
      leasureInterestArray,
      packageTypeArray
    };
  };
  const analyticsIconClickHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailIconClickAnalytics'], params));
  };
  const analyticsEmailSubmitClickHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailSubmitClickAnalytics'], params), buttonText);
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['EmailSuccessAnalytics'], params));
  };
  const analyticsCloseBeforeIconClickHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeBeforeAnalytics'], params));
  };
  const analyticsCloseAfterIconClickHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeAfterAnalytics'], params));
  };
  const analyticsGrayCloseClickHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['closeGreyAnalytics'], params));
  };
  const analyticsPopupLoadedHandler = () => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['popupLoadedAnalytics'], params));
  };
  const sendEmail = async e => {
    e.preventDefault();
    const {
      travellerTypeArray,
      leasureInterestArray,
      packageTypeArray
    } = getFormDataFromQueryString();
    const requestParams = new URLSearchParams({
      json: JSON.stringify({
        Subscriberkey: emailInputValue,
        Traveller_Type: travellerTypeArray.length ? travellerTypeArray.join(",") : null,
        Leasure_Interest: leasureInterestArray.length ? leasureInterestArray.join(",") : null,
        Package_Type: packageTypeArray.length ? packageTypeArray.join(",") : null,
        Language: language,
        Hidden_City: "Dubai",
        Hidden_Country: "AE",
        Email_Address: emailInputValue,
        url: canUseDOM ? window.location.href : "",
        Email_Consent: "true"
      })
    }).toString();
    fetch(aPIUrl, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      method: "POST",
      body: requestParams
    }).then(res => {
      if (res.status === 200) {
        setEmailSentSuccessful(true);
        analyticsEmailSubmitClickHandler();
      }
    }).catch(err => {
      console.log("err", err);
      throw new Error(err);
    });
  };
  const openFormHandler = () => {
    setOpenForm(true);
  };
  const closeForm = () => {
    setOpenForm(false);
  };
  const closeFormWithOutsideClick = () => {
    closeForm();
    analyticsGrayCloseClickHandler();
  };
  const closeFormWithAnalytics = () => {
    closeForm();
    analyticsCloseBeforeIconClickHandler();
  };
  const closeFormAndRemoveBlueLine = () => {
    closeForm();
    if (canUseDOM) {
      const element = document.getElementById("successBlueLine");
      if (isNotNil(element)) {
        element.classList.remove("blueLine");
      }
    }
    analyticsCloseAfterIconClickHandler();
  };
  const isButtonEnabled = () => Boolean(emailInputValue.trim().length) && checkboxValue;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `surpriseMeFormWrapper ${openForm ? "visibleForm" : "hiddenForm"}`
  }, !emailSentSuccessful ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "formWithLine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseMeForm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subtitle"
  }, subtitle), /*#__PURE__*/React.createElement("form", {
    onSubmit: sendEmail
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    className: "emailInput",
    placeholder: "Email Address *",
    value: emailInputValue,
    onChange: value => {
      setEmailInputValue(value.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscription"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "subscription",
    className: "subscriptionCheckbox",
    checked: checkboxValue,
    onChange: value => {
      setCheckboxValue(value.target.checked);
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "subscription"
  }, subscriptionText)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: `btn btn-primary sendEmailButton ${isButtonEnabled() ? "" : "disabled"}`,
    disabled: !isButtonEnabled()
  }, buttonText)), /*#__PURE__*/React.createElement("p", {
    className: "policy",
    dangerouslySetInnerHTML: {
      __html: policyText
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: "closeBtn",
    onClick: closeFormWithAnalytics
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "iconClose"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "blueLine"
  })), /*#__PURE__*/React.createElement("div", {
    className: `notification ${openForm ? "hiddeNotification" : "visibleNotification"}`,
    onClick: () => {
      clearTimeout(timerOpenFormId.current);
      openFormHandler();
      analyticsIconClickHandler();
    }
  }, /*#__PURE__*/React.createElement(IconMailBox, {
    className: "iconNotification"
  }), /*#__PURE__*/React.createElement("div", {
    className: "notificationCircle"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "formWithLine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "surpriseMeForm"
  }, /*#__PURE__*/React.createElement("p", {
    className: "successMessageTitle"
  }, successMessageTitle), /*#__PURE__*/React.createElement("p", null, successMessageText), /*#__PURE__*/React.createElement("button", {
    className: "closeBtn",
    onClick: closeFormAndRemoveBlueLine
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "iconClose"
  }))), /*#__PURE__*/React.createElement("div", {
    id: "successBlueLine",
    className: "blueLine"
  }))), /*#__PURE__*/React.createElement("div", {
    onClick: closeFormWithOutsideClick,
    className: `${openForm ? "surpriseMeFormWrapperBlur" : "surpriseMeFormWrapperNoBlur"}`
  }));
};
const SurpriseMeForm = props => checkJssError(props, SurpriseMeFormComponent, props.fields.data.listingConfiguration);
const StyledWrapper = _ref5 => {
  let {
    children,
    rtl
  } = _ref5;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`
  }, children);
};
const commonStyles = "cssa1ql";
const rtlStyles = "ranue4e";
const ltrStyles = "lqniqbv";
export default SurpriseMeForm;